module.exports = __webpack_public_path__ + "assets/img/4.610c9d30.png";